import { useEffect, useRef } from 'react';

export default function useWs(tenantId, onMsg) {
  const cb = useRef(onMsg);
  cb.current = onMsg;
  useEffect(() => {
    if (!tenantId) return;
    let ws, dead = false, retry;
    const connect = () => {
      try {
        const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, 'ws');
        ws = new WebSocket(`${base}/api/ws/${tenantId}`);
        ws.onmessage = (e) => { try { cb.current(JSON.parse(e.data)); } catch (err) {} };
        ws.onclose = () => { if (!dead) retry = setTimeout(connect, 5000); };
      } catch (err) { retry = setTimeout(connect, 5000); }
    };
    connect();
    return () => { dead = true; clearTimeout(retry); if (ws) ws.close(); };
  }, [tenantId]);
}
